<template>
  <card> </card>
</template>
<script>
export default {
  name: "quit",
  mounted() {
    this.$http.defaults.headers.common["Authorization"] = null;
    this.$http.defaults.headers.common["root"] = null;
    this.$http.defaults.headers.common["bid"] = null;
    localStorage.removeItem("root");
    localStorage.removeItem("token");
    localStorage.removeItem("bid");
    this.$store.dispatch("setRoot", false);
    this.$store.dispatch("setUser", null);
    this.$store.dispatch("setBusiness", null);
    this.$store.dispatch("setRoutes", []);
    setTimeout(() => {
      try {
        this.$router.push("/dashboard");
      } catch (error) {}
    }, 100);
  },
};
</script>
<style>
</style>
